export const stripePlansPrices: { [key: string]: number } = {
  single: 299,
  monthly: 599,
};
